import FormBase from "../../forms/FormBase";
import PersonalDataForm from "../../forms/shared/PersonalDataForm";
import AddressDataForm, { AddressType } from "../../forms/shared/AddressDataForm";
import ReRegistrationVocationalTrainingForm from "../../forms/recadastramento/ReRegistrationVocationalTrainingForm";
import ReRegistrationAcademicDegreeForm from "../../forms/recadastramento/ReRegistrationAcademicDegreeForm";
import ReRegistrationCourseForm from "../../forms/recadastramento/ReRegistrationCourseForm";
import ReRegistrationMedicalLinkForm from "../../forms/recadastramento/ReRegistrationMedicalLinkForm";
import BusinessDataForm from "../../forms/shared/BusinessForm";
import PersonalAddressDataForm from "../../forms/corpoClinico/PersonalAddressDataForm";
import PhysicianRecommendationDataForm, { PhysicianRecommendationDataFormItem } from "../../forms/corpoClinico/PhysicianRecommendationDataForm";
import InterestReasonsDataForm from "../../forms/corpoClinico/InterestReasonsDataForm";
import TermsDeclarationsForm from "../../forms/corpoClinico/TermsDeclarationsForm";
import Professional from "../../models/Professional";
import Request from "../../models/Request";
import { RecadastramentoStepForm } from "../../config/RecadastramentoStepForm";
import FormFieldBase from "../../forms/FormFieldBase";
import SupplierDeclarationForm, { SupplierDeclarationItem } from "../../forms/shared/termsDeclarations/SupplierDeclarationForm";
import RefusalPresentVaccineForm, { RefusalPresentVaccineItem } from "../../forms/shared/termsDeclarations/RefusalPresentVaccineForm";
import GuideForm from "../../forms/shared/GuideForm";
import ReducerBase from "./ReducerBase";
import { ICRUDReRegistrationAcademicDegreeForm, ICRUDReRegistrationCourseForm, ICRUDReRegistrationMedicalLinkForm, ICRUDReRegistrationProfessionalPrivilegeForm, ICRUDReRegistrationProfessionalTeamForm, ICRUDReRegistrationTeamMembersForm, ICRUDReRegistrationVocationalTrainingForm, IUpdateForm, IUpdateFormAttachment, IUpdateFormAttachmentDynamic } from "./interfaces/IRecadastramentoReducer";
import ReRegistrationTeamMembersForm from "../../forms/recadastramento/ReRegistrationTeamMembersForm";
import ReRegistrationProfessionalTeamForm from "../../forms/recadastramento/ReRegistrationProfessionalTeamForm";
import ReRegistrationAttachmentForm from "../../forms/recadastramento/ReRegistrationAttachmentForm";
import ReRegistrationProfessionalPrivilegeForm from "../../forms/recadastramento/ReRegistrationProfessionalPrivilegeForm";

export interface IRecadastramentoState {
  GuideForm: GuideForm; //ok
  PersonalDataForm: PersonalDataForm; //ok
  AddressDataForm: AddressDataForm; //ok
  ReRegistrationVocationalTrainingForm: ReRegistrationVocationalTrainingForm;//ok
  ReRegistrationAcademicDegreeForm: ReRegistrationAcademicDegreeForm;//ok
  ReRegistrationCourseForm: ReRegistrationCourseForm;//ok
  ReRegistrationMedicalLinkForm: ReRegistrationMedicalLinkForm;//ok
  ReRegistrationTeamMembersForm: ReRegistrationTeamMembersForm;//ok
  ReRegistrationProfessionalTeamForm: ReRegistrationProfessionalTeamForm;//ok
  ReRegistrationProfessionalPrivilegeForm: ReRegistrationProfessionalPrivilegeForm;//ok
  BusinessDataForm: BusinessDataForm;
  BusinessAddressDataForm: AddressDataForm;
  AttachmentForm: ReRegistrationAttachmentForm;
  PhysicianRecommendationDataForm: PhysicianRecommendationDataForm;
  InterestReasonsDataForm: InterestReasonsDataForm;
  PersonalAddressDataForm: PersonalAddressDataForm;
  TermsDeclarationsForm: TermsDeclarationsForm;
  SupplierDeclarationForm: SupplierDeclarationForm;
  RefusalPresentVaccineForm: RefusalPresentVaccineForm;
  CurrentStep: number;
  MessageErrorToGoStep: string[];
  Loading: boolean;
  Professional: Professional;
  Request: Request;
  Protocol: string;
}

interface IUpdateFormRefusalPresentVaccineItemData {
  type: "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM";
  payload: {
    form: FormBase;
    name: string;
    value: any;
    item: RefusalPresentVaccineItem;
  };
}

interface ICRUDFormPhysicianRecommendationData {
  type: "CRUD_FORM_PHYSICIAN_RECOMMENDATION";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: PhysicianRecommendationDataFormItem;
  };
}

interface ICRUDFormSupplierDeclarationData {
  type: "CRUD_FORM_SUPPLIER_DECLARATION";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: SupplierDeclarationItem;
  };
}

interface IGoToNextStep {
  type: "GO_TO_NEXT_STEP";
  payload: { messagesError: string[] };
}

interface IGoToBackStep {
  type: "GO_TO_BACK_STEP";
}

interface IProcessingInfo {
  type: "LOADING";
  payload: { processing: boolean };
}
interface ISetProfessionalId {
  type: "SET_PROFESSIONAL";
  payload: {
    response: any;
  };
}
interface ISetProtocol {
  type: "SET_PROTOCOL";
  payload: {
    response: any;
  };
}

interface IResetState {
  type: "RESET_STATE";
}

export type Actions =
  | IUpdateForm
  | IGoToNextStep
  | IGoToBackStep
  | ICRUDReRegistrationVocationalTrainingForm
  | ICRUDReRegistrationCourseForm
  | ICRUDReRegistrationMedicalLinkForm
  | ICRUDReRegistrationAcademicDegreeForm
  | ICRUDReRegistrationTeamMembersForm
  | ICRUDReRegistrationProfessionalTeamForm
  | ICRUDReRegistrationProfessionalPrivilegeForm
  | ICRUDFormSupplierDeclarationData
  | ICRUDFormPhysicianRecommendationData
  | IUpdateFormRefusalPresentVaccineItemData
  | ISetProfessionalId
  | ISetProtocol
  | IProcessingInfo
  | IUpdateFormAttachment
  | IUpdateFormAttachmentDynamic
  | IResetState;

export const initialState: IRecadastramentoState = {
  GuideForm: GuideForm.NewInstance(),
  PersonalDataForm: PersonalDataForm.NewInstance(),
  AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
  ReRegistrationVocationalTrainingForm: ReRegistrationVocationalTrainingForm.NewInstance(),
  ReRegistrationAcademicDegreeForm: ReRegistrationAcademicDegreeForm.NewInstance(),
  ReRegistrationMedicalLinkForm: ReRegistrationMedicalLinkForm.NewInstance(),
  ReRegistrationCourseForm: ReRegistrationCourseForm.NewInstance(),
  ReRegistrationTeamMembersForm: ReRegistrationTeamMembersForm.NewInstance(),
  ReRegistrationProfessionalTeamForm: ReRegistrationProfessionalTeamForm.NewInstance(),
  ReRegistrationProfessionalPrivilegeForm: ReRegistrationProfessionalPrivilegeForm.NewInstance(),
  BusinessDataForm: BusinessDataForm.NewInstance(),
  BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
  AttachmentForm: ReRegistrationAttachmentForm.NewInstance(),
  PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
  PhysicianRecommendationDataForm: PhysicianRecommendationDataForm.NewInstance(),
  InterestReasonsDataForm: InterestReasonsDataForm.NewInstance(),
  TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
  RefusalPresentVaccineForm: RefusalPresentVaccineForm.NewInstance(),
  SupplierDeclarationForm: SupplierDeclarationForm.NewInstance(),
  CurrentStep: 1,
  MessageErrorToGoStep: [],
  Loading: false,
  Professional: Professional.NewInstance(),
  Request: Request.NewInstance(),
  Protocol: "",
};

export const reducer = (state: IRecadastramentoState, action: Actions) => {
  switch (action.type) {
    case "UPDATE_FORM": {
      const { form, name, value } = action.payload;

      (form.GetFieldByName(name) as FormFieldBase).Value = value;
      (form.GetFieldByName(name) as FormFieldBase).InputChange(value);
      (form.GetFieldByName(name) as FormFieldBase).ValidateField();

      return { ...state };
    }

    case "UPDATE_FORM_ATTACHMENT": {
      const { form, name, value, subType, id, errorMessage, loading } = action.payload;

      ReducerBase.updateFileActions(form, name, value, subType, errorMessage, id, loading);


      return { ...state };
    }

    case "UPDATE_FORM_ATTACHMENT_DYNAMIC": {
      const { value, subType, id, errorMessage, loading, reRegistrationAttachmentFormItem } = action.payload;

      switch (subType) {
        case "Insert":
          if (reRegistrationAttachmentFormItem.FileField !== undefined) {
            const files = [...reRegistrationAttachmentFormItem.FileField.Values];
            files.push(value);
            reRegistrationAttachmentFormItem.FileField.Values = files;
          }
          break;

        case "Delete":
          if (reRegistrationAttachmentFormItem.FileField !== undefined) {
            var index = reRegistrationAttachmentFormItem.FileField.Values.findIndex((f) => f.HashName === value.HashName);
            const newFiles = [...reRegistrationAttachmentFormItem.FileField.Values];
            newFiles.splice(index, 1);
            reRegistrationAttachmentFormItem.FileField.Values = newFiles;
          }
          break;

        case "Loading":
          if (loading) {
            if (reRegistrationAttachmentFormItem.FileField !== undefined) {
              let index = reRegistrationAttachmentFormItem.FileField.Values.findIndex((f) => f.HashName === value.HashName);
              const newFiles = [...reRegistrationAttachmentFormItem.FileField.Values];
              newFiles[index].IsLoading = loading;
              reRegistrationAttachmentFormItem.FileField.Values = newFiles;
            }
          }
          break;

        case "UpdateId":
          if (id) {
            if (reRegistrationAttachmentFormItem.FileField !== undefined) {
              let index = reRegistrationAttachmentFormItem.FileField.Values.findIndex((f) => f.HashName === value.HashName);
              const newFiles = [...reRegistrationAttachmentFormItem.FileField.Values];
              newFiles[index].Id = id;
              reRegistrationAttachmentFormItem.FileField.Values = newFiles;
            }
          }
          break;

        case "Error":
          if (errorMessage) {
            if (reRegistrationAttachmentFormItem.FileField !== undefined) {
              let index = reRegistrationAttachmentFormItem.FileField.Values.findIndex((f) => f.HashName === value.HashName);
              const newFiles = [...reRegistrationAttachmentFormItem.FileField.Values];
              newFiles[index].ErrorMessage = errorMessage;
              reRegistrationAttachmentFormItem.FileField.Values = newFiles;
            }
          }
          break;
        default:
          break;
      }

      if (reRegistrationAttachmentFormItem.FileField !== undefined) {
        reRegistrationAttachmentFormItem.FileField.ValidateField();
      }

      return { ...state };
    }

    case "SET_PROFESSIONAL": {
      const { response } = action.payload;

      let professional = new Professional(response.encriptId, response.name);

      return { ...state, Professional: professional };
    }
    case "SET_PROTOCOL": {
      const { response } = action.payload;

      return { ...state, Protocol: response.protocol };
    }

    case "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM": {
      const { name, value, item } = action.payload;

      switch (name) {
        case "Checked":
          item.Checked.Value = value;
          break;
        case "ApplyDate":
          item.ApplyDate.Value = value;
          break;
        case "Reason":
          item.Reason.Value = value;
          break;

        default:
          break;
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_VOCATION_TRANING": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationVocationalTrainingForm.AddOrUpdateReRegistrationVocationalTrainingFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationVocationalTrainingForm.EditReRegistrationVocationalTrainingFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationVocationalTrainingForm.RemoveReRegistrationVocationalTrainingFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationVocationalTrainingForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_ACADEMIC_DEGREE": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationAcademicDegreeForm.AddOrUpdateReRegistrationAcademicDegreeFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationAcademicDegreeForm.EditReRegistrationAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationAcademicDegreeForm.RemoveReRegistrationAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationAcademicDegreeForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_COURSE": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationCourseForm.AddOrUpdateReRegistrationCourseFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationCourseForm.EditReRegistrationCourseFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationCourseForm.RemoveReRegistrationCourseFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationCourseForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_MEDICAL_LINK": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationMedicalLinkForm.AddOrUpdateReRegistrationMedicalLinkFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationMedicalLinkForm.EditReRegistrationMedicalLinkFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationMedicalLinkForm.RemoveReRegistrationMedicalLinkFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationMedicalLinkForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_TEAM_MEMBERS": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationTeamMembersForm.AddOrUpdateReRegistrationTeamMembersFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationTeamMembersForm.EditReRegistrationTeamMembersFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationTeamMembersForm.RemoveReRegistrationTeamMembersFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationTeamMembersForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_TEAM_I_PARTICIPATE_IN": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationProfessionalTeamForm.AddOrUpdateReRegistrationProfessionalTeamFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationProfessionalTeamForm.EditReRegistrationProfessionalTeamFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationProfessionalTeamForm.RemoveReRegistrationProfessionalTeamFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationProfessionalTeamForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_REREGISTRATION_PROFESSIONAL_PRIVILEGE": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.ReRegistrationProfessionalPrivilegeForm.AddOrUpdateReRegistrationProfessionalPrivilegeFormItem();
      } else if (subType === "Edit") {
        state.ReRegistrationProfessionalPrivilegeForm.EditReRegistrationProfessionalPrivilegeFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.ReRegistrationProfessionalPrivilegeForm.RemoveReRegistrationProfessionalPrivilegeFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.ReRegistrationProfessionalPrivilegeForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_PHYSICIAN_RECOMMENDATION": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.PhysicianRecommendationDataForm.AddOrUpdatePhysicianRecommendationDataFormItem();
      } else if (subType === "Edit") {
        state.PhysicianRecommendationDataForm.EditPhysicianRecommendationDataFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.PhysicianRecommendationDataForm.RemovePhysicianRecommendationDataFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.PhysicianRecommendationDataForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_SUPPLIER_DECLARATION": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.SupplierDeclarationForm.AddOrUpdateSupplierDeclarationItem();
      } else if (subType === "Edit") {
        state.SupplierDeclarationForm.EditSupplierDeclarationItem(
          item?.Id || 0
        );
      } else if (subType === "Delete") {
        state.SupplierDeclarationForm.RemoveSupplierDeclarationItem(
          item?.Id || 0
        );
      } else if (subType === "Cancel") {
        state.SupplierDeclarationForm.ResetSupplierForm();
      }

      return { ...state };
    }

    case "GO_TO_NEXT_STEP": {
      const { messagesError } = action.payload;

      //Se houver mensagens de erro, não pode avançar a etapa
      if (messagesError.length === 0) {
        if (state.CurrentStep < RecadastramentoStepForm.length) {
          return {
            ...state,
            CurrentStep: state.CurrentStep + 1,
            MessageErrorToGoStep: [],
          };
        }
      } else {
        return { ...state, MessageErrorToGoStep: messagesError };
      }

      return { ...state };
    }

    case "GO_TO_BACK_STEP":
      if (state.CurrentStep > 1) {
        return {
          ...state,
          CurrentStep: state.CurrentStep - 1,
          MessageErrorToGoStep: [],
        };
      }
      return { ...state };

    case "LOADING":
      const { processing: loading } = action.payload;

      return { ...state, Loading: loading };

    case "RESET_STATE":

      return {
        ...state,
        GuideForm: GuideForm.NewInstance(),
        PersonalDataForm: PersonalDataForm.NewInstance(),
        AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
        ReRegistrationVocationalTrainingForm: ReRegistrationVocationalTrainingForm.NewInstance(),
        ReRegistrationAcademicDegreeForm: ReRegistrationAcademicDegreeForm.NewInstance(),
        ReRegistrationCourseForm: ReRegistrationCourseForm.NewInstance(),
        ReRegistrationMedicalLinkForm: ReRegistrationMedicalLinkForm.NewInstance(),
        ReRegistrationTeamMembersForm: ReRegistrationTeamMembersForm.NewInstance(),
        BusinessDataForm: BusinessDataForm.NewInstance(),
        BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
        AttachmentForm: ReRegistrationAttachmentForm.NewInstance(),
        PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
        PhysicianRecommendationDataForm: PhysicianRecommendationDataForm.NewInstance(),
        InterestReasonsDataForm: InterestReasonsDataForm.NewInstance(),
        TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
        RefusalPresentVaccineForm: RefusalPresentVaccineForm.NewInstance(),
        SupplierDeclarationForm: SupplierDeclarationForm.NewInstance(),
        CurrentStep: 1,
        MessageErrorToGoStep: [],
        Loading: false,
        Professional: Professional.NewInstance(),
        Protocol: "",
      };

    default:
      return { ...state };
  }
};

export function getStateFormPropertyByName(name: string, state: IRecadastramentoState): any {
  switch (name) {
    case "GuideForm":
      return state.GuideForm;
    case "PersonalDataForm":
      return state.PersonalDataForm;
    case "AddressDataForm":
      return state.AddressDataForm;
    case "BusinessDataForm":
      return state.BusinessDataForm;
    case "BusinessAddressDataForm":
      return state.BusinessAddressDataForm;
    case "AttachmentForm":
      return state.AttachmentForm;
    case "ReRegistrationVocationalTrainingForm":
      return state.ReRegistrationVocationalTrainingForm;
    case "ReRegistrationAcademicDegreeForm":
      return state.ReRegistrationAcademicDegreeForm;
    case "ReRegistrationMedicalLinkForm":
      return state.ReRegistrationMedicalLinkForm;
    case "ReRegistrationTeamMembersForm":
      return state.ReRegistrationTeamMembersForm;
    case "ReRegistrationProfessionalTeamForm":
      return state.ReRegistrationProfessionalTeamForm;
    case "ReRegistrationCourseForm":
      return state.ReRegistrationCourseForm;
    case "PhysicianRecommendationDataForm":
      return state.PhysicianRecommendationDataForm;
    case "InterestReasonsDataForm":
      return state.InterestReasonsDataForm;
    case "PersonalAddressDataForm":
      return state.PersonalAddressDataForm;
    case "TermsDeclarationsForm":
      return state.TermsDeclarationsForm;
    case "SupplierDeclarationForm":
      return state.SupplierDeclarationForm;
    case "RefusalPresentVaccineForm":
      return state.RefusalPresentVaccineForm;
    case "ReRegistrationProfessionalPrivilegeForm":
      return state.ReRegistrationProfessionalPrivilegeForm;
    default:
      console.error(`O Formulário ${name} não está mapeando no reducer`);
      break;
  }
}
